import request from "../shared/http";
import appConfig from "../shared/js/app-config";

class CheckoutService {
    async getCartItems(storeId, variantIds) {
        const url = `/checkout/${storeId}`;
        const { data } = await request.get(url, {
            params: {
                productIds: variantIds.join(','),
            },
        });
        return data;
    }

    async createCart(payload) {
        const url = `/checkout/${appConfig.getServiceId()}`;
        const { data } = await request.post(url, { payload });
        return data;
    }

    async sendOrderMessage(products, number, serviceId, paymentOption, upiId, order, checkoutPayload) {
        const url = `/checkout/message/${serviceId}`;
        const { data } = await request.post(url, { products, phoneNumber: number, paymentOption, upiId, order, checkoutPayload });
        return data;
    }

    async getOrderDetails(payload) {
        console.log('payload', payload);
        
        const url = `/order/details`;
        const { data } = await request.post(url, payload);
        return data;
    }
}
export default new CheckoutService();